import { Card, Icon, Section, StatusBadge, Tag } from '@ui/library';
import type { Project } from '@lib/schemas/project';

export interface ProjectsCopy {
  eyebrow: string;
  title: string;
  lead: string;
}

export interface ProjectsProps {
  items: ReadonlyArray<Project>;
  copy: ProjectsCopy;
}

export function Projects({ items, copy }: ProjectsProps) {
  return (
    <Section id="projects" eyebrow={copy.eyebrow} title={copy.title} lead={copy.lead}>
      <div className="projects" style={{ marginTop: 40 }}>
        {items.map((p, i) => (
          <Card key={p.name} variant="proj" href={p.href} staggerIndex={i}>
            <div className="proj__top">
              <StatusBadge status={p.status} />
              <Icon name="arrow-up-right" size={18} />
            </div>
            <h3>{p.name}</h3>
            <p className="proj__desc">{p.desc}</p>
            <div className="proj__tags">
              {p.tags.map((t) => <Tag key={t}>{t}</Tag>)}
            </div>
          </Card>
        ))}
      </div>
    </Section>
  );
}
